@use "@sass/helper";

.dropdownToggle {
  color: helper.$blue;
  border: 0;
  border-bottom: solid 3px helper.$blue;
  text-decoration: none;
  &:hover, &:active {
    text-decoration: none;
  }
}
